import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientAssignmentHistoryEntity } from './client-assignment-history.entity';

@Entity('client_assignment_job')
export class ClientAssignmentJobEntity extends BaseEntity {
	@Column('varchar', { name: 'job', length: 255 })
	public job!: string;

	@OneToMany(
		() => ClientAssignmentHistoryEntity,
		(clientAssignmentHistory) => clientAssignmentHistory.fkClientAssignmentJob,
		{},
	)
	public clientAssignmentHistories!: Array<ClientAssignmentHistoryEntity>;
}
